import incense from '@mortgage-pos/ui/incense'
import useDeepCompareEffect from './useDeepCompareEffect'
import { customFormValidations } from '@mortgage-pos/ui/utils/customFormValidations'

/**
 * A custom hook which utilizes customFormValidations to run a custom validation method.
 * The key should be equal to one of the method names, which will return a conditional to run the callback
 *
 * @param values - Any value, Passed to the custom valiation method to be validated
 * @param key - A string which should match the name of a method on customFormValidations
 * @param onValidatedCallback - A function to be called when validated
 * @returns { void }
 */

export default function useCustomValidation(
  values: any,
  key: string,
  onValidatedCallback: Function
) {
  useDeepCompareEffect(() => {
    if (!key) {
      return
    }

    if (customFormValidations[key]) {
      const validation = customFormValidations[key](values)

      if (onValidatedCallback) {
        onValidatedCallback(validation)
      }
    } else {
      incense()
        .details({
          name: 'UseCustomValidationError',
          message: 'No custom repeatable validation logic for condition',
        })
        .safe({ key })
        .sensitive({ values })
        .error()
    }
  }, [values])
}
